import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import homeDefaultSetting from "./utils/tileData";
import { getHome, updateHome } from "./utils/helper";
import TileItem from "./components/TileItem";
import TileSetting from "./dialog/TileSetting";
import AutoSetting from "./dialog/AutoSetting";
import ManualSetting from "./dialog/ManualSetting";
import Layout from "./components/Layout";
import localStorage from "src/utils/local-storage";
import HeaderMobileComponent from "src/components/layout/header-mobile";
import TrendingTag from './components/TrendingTag';
import {
  getUpdatedHome,
  buildKey,
  getPostsByTile,
  getPrPosts,
} from "./utils/getUpdatedHome";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import { getSession, updateSession, deleteSession } from "./utils/session";
import getPrType from "../../utils/prType";
const prTypes = getPrType();

SwiperCore.use([Pagination, Autoplay]);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper,
    margin: "80px auto 10px auto",
    width: "1200px",
    paddingLeft: "40px",
    paddingRight: "40px",
  },
  root2: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper,
    margin: "16px auto 36px auto",
    width: "1200px",
    paddingLeft: "40px",
    paddingRight: "40px",
  },
  rootMobile: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "15px",
  },
  gridList: {
    width: "calc(100% - 350px)",
  },
  gridList2: {
    width: "100%",
  },
  gridListMobile: {
    flexDirection: "column",
    // borderBottom: "307px solid #F0F3F6",
  },
  gridListMobile2: {
    flexDirection: "column",
  },
  gridItem: {
    backgroundColor: "rgba(255, 255, 255, 0.54)",
  },
  gridItemMobile: {
    width: "100% !important",
    borderBottom: "1px solid rgba(255,71,78,.5)",
    paddingBottom: "20px !important",
    "& .top-2": {
      maxWidth: "100%",
    },
    "& .top-2 .cate-time": {
      display: "flex !important",
    },
  },
  gridItemMobile2: {
    width: "100% !important",
  },
  icon: {
    color: "rgba(255, 255, 255, 0.54)",
  },
  saveBtn: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(3),
  },
}));

const Home = () => {
  const user = localStorage.get("_user");

  const classes = useStyles();

  const [backdropStatus, setBackdropStatus] = useState(false);
  const [alertDialogStatus, setAlertDialogStatus] = useState(false);
  const [alertDialogData, setAlertDialogData] = useState(null);
  const [confirmDialogStatus, setConfirmDialogStatus] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState(null);
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarData, setSnackBarData] = useState(null);

  const [home, setHome] = useState(homeDefaultSetting);

  const [settingStatus, setSettingStatus] = useState(false);
  const [autoSettingStatus, setAutoSettingStatus] = useState(false);
  const [manualSettingStatus, setManualSettingStatus] = useState(false);

  const [currentTileIndex, setCurrentTileIndex] = useState(null);
  const [currentTileData, setCurrentTileData] = useState(null);

  const [dataPosts, setDataPosts] = useState({});

  const [isMounted, setIsMounted] = useState(true);

  const fetchData = async () => {
    setBackdropStatus(true);

    const homeData = await getHome();
    const mappedTiles =
      home.tiles &&
      home.tiles.map((p, index) => {
        return {
          ...p,
          ...(homeData.tiles[index] && { ...homeData.tiles[index] }),
        };
      });
    const newHome = {
      ...homeData,
      tiles: mappedTiles,
    };
    setHome(newHome);

    await getDataPosts(homeData.tiles);

    setBackdropStatus(false);
  };

  const openSetting = (tile, index) => {
    setSettingStatus(true);
    setCurrentTileIndex(index);
    setCurrentTileData(tile);
  };

  const closeSetting = (selectedType) => {
    setSettingStatus(false);

    if (selectedType) {
      if (selectedType === "auto") {
        setAutoSettingStatus(true);
      }
      if (selectedType === "manual") {
        setManualSettingStatus(true);
      }
    } else {
      setCurrentTileIndex(null);
      setCurrentTileData(null);
    }
  };

  const closeAutoSetting = async (autoSettingData) => {
    setAutoSettingStatus(false);
    setCurrentTileIndex(null);
    setCurrentTileData(null);

    if (autoSettingData) {
      await updateHomeData(currentTileIndex, autoSettingData);
    }
  };

  const closeManualSetting = async (manualSettingData) => {
    setManualSettingStatus(false);
    setCurrentTileIndex(null);
    setCurrentTileData(null);
    if (manualSettingData) {
      await updateHomeData(currentTileIndex, manualSettingData);
    }
  };

  const getListPRPosts = async(data) => {
    await Promise.all(prTypes.map(async (prType) => {
      if(prType.value && prType.value != "0" && prType.expiredTime){
        const prTypePosts = await getPrPosts(prType.value);
        data[`pr_type=${prType.value}`] = prTypePosts;
      }
    }));
    return data;
  }

  const getDataPosts = async (tiles) => {
    if(tiles){
      const data = {};
      for (const tile of tiles) {
        if (tile.type === "auto") {
          const key = buildKey(tile);

          if (!data.hasOwnProperty(key)) {
            const posts = await getPostsByTile(tile);
            data[key] = posts;
          }
        }
      }
      await getListPRPosts(data);
      setDataPosts(data);
    }
  };

  const updateHomeData = async (position, tile) => {
    home.tiles[position] = tile;
    setBackdropStatus(true);

    const key = buildKey(tile);
    if (!dataPosts[key]) {
      const posts = await getPostsByTile(tile);
      dataPosts[key] = posts;
      const data = {
        ...dataPosts,
      };
      setDataPosts(data);
    }
    console.log("lấy lại ds pr posts");
    const data = {
      ...dataPosts,
    };
    //fix lỗi nếu không lấy lại data posts pr thì lần set home 2 sẽ bị lỗi
    await getListPRPosts(data);
    setDataPosts(data);
    const newTiles = getUpdatedHome(home.tiles, dataPosts);
    home.tiles = newTiles;
    setBackdropStatus(false);

    saveHomeData();
  };

  const saveHomeData = (homeData = null) => {
    updateHome(homeData || home)
      .then((data) => {
        showSnackBar({ mess: "Đã lưu trang chủ", type: "success" });
      })
      .catch(function(error) {
        console.error(error);
        showAlertDialog({
          title: "Có lỗi xảy ra",
          body: error.messages[0].message,
          onClose: goToPostList,
        });
      });
  };

  const showAlertDialog = (data) => {
    setAlertDialogStatus(true);
    setAlertDialogData(data);
  };

  const showConfirmDialog = (data) => {
    setConfirmDialogStatus(true);
    setConfirmDialogData(data);
  };

  const showSnackBar = (data) => {
    setSnackBarStatus(true);
    setSnackBarData(data);
  };

  const goToPostList = () => {
    window.location.href = "/";
  };

  const handleSession = () => {
    getSession().then((lock) => {
      if (!lock.value) {
        updateSession(lock, user.email);
      } else {
        // luôn cho phép chiếm quyền
        let body = `Trang chủ đang được cài đặt bởi ${lock.value}`;
        if (lock.value === user.email) {
          body = "Bạn đang thực hiện cấu hình trang chủ trên một cửa sổ khác.";
        }
        showConfirmDialog({
          title: "Thông báo",
          body,
          yesText: "Chiếm quyền",
          noText: "Thoát",
          onConfirm: (confirm) => {
            if (confirm) {
              updateSession(lock, user.email, true);
            } else {
              goToPostList();
            }
          },
        });
      }
    });
  };

  // HANDLE DRAGGABLE ITEM
  const swapBoxes = (fromBox, toBox) => {
    let boxes = home.tiles.slice();
    let fromIndex = -1;
    let toIndex = -1;

    for (let i = 0; i < boxes.length; i++) {
      if (boxes[i].id === fromBox.id) {
        fromIndex = i;
      }
      if (boxes[i].id === toBox.id) {
        toIndex = i;
      }
    }

    if (fromIndex != -1 && toIndex != -1) {
      let { fromId, ...fromRest } = boxes[fromIndex];
      let { toId, ...toRest } = boxes[toIndex];
      boxes[fromIndex] = {
        ...toRest,
        id: fromBox.id,
        _id: fromBox._id,
        className: fromRest.className,
        cols: fromRest.cols,
        rows: fromRest.rows,
        cardType: fromRest.cardType,
        cardMobileType: fromRest.cardMobileType,
        thumbSize: fromRest.thumbSize,
        thumbType: fromRest.thumbType,
        thumbMobileType: fromRest.thumbMobileType,
        pr: fromRest.pr,
      };
      boxes[toIndex] = {
        ...fromRest,
        id: toBox.id,
        _id: toBox._id,
        className: toRest.className,
        cols: toRest.cols,
        rows: toRest.rows,
        cardType: toRest.cardType,
        cardMobileType: toRest.cardMobileType,
        thumbSize: toRest.thumbSize,
        thumbType: toRest.thumbType,
        thumbMobileType: toRest.thumbMobileType,
        pr: toRest.pr,
      };

      if (boxes[fromIndex] && boxes[fromIndex].post && boxes[fromIndex].post.pr_type !== "0") {
        return;
      }

      if (boxes[toIndex] && boxes[toIndex].post && boxes[toIndex].post.pr_type !== "0") {
        return;
      }
      
      const newHome = {
        ...home,
        tiles: boxes,
      };
      setHome(newHome);
      saveHomeData(newHome);
    }
  };

  // FOR DESKTOP
  const handleDragStart = (data) => (event) => {
    let fromBox = JSON.stringify({ id: data.id });
    event.dataTransfer.setData("dragContent", fromBox);
  };

  const handleDragOver = (data) => (event) => {
    event.preventDefault(); // Necessary. Allows us to drop.
    return false;
  };

  const handleDrop = (data) => (event) => {
    event.preventDefault();

    let fromBox = JSON.parse(event.dataTransfer.getData("dragContent"));
    let toBox = { id: data.id };

    swapBoxes(fromBox, toBox);
    return false;
  };
  // END FOR DESKTOP  

  // FOR MOBILE
  const [switchPositionTile, setSwitchPositionTile] = useState(null);
  useEffect(() => {
    if (switchPositionTile) {
      console.log(switchPositionTile.id);
    }
  }, [switchPositionTile]);
  const handleSwitchPosition = (status, tile) => {
    console.log("handleSwitchPosition", status, tile.id);
    if (status) {
      if (switchPositionTile && tile && switchPositionTile.id === tile.id) {
        // huỷ
        setSwitchPositionTile(null);
      } else {
        // đổi vị trí
        setSwitchPositionTile(tile);
      }
    } else {
      // swap boxes
      setSwitchPositionTile(null);

      if (switchPositionTile && tile) {
        swapBoxes({id: switchPositionTile.id}, {id: tile.id});
      }
    }

  }
  // END FOR MOBILE
  // END HANDLE DRAGGABLE ITEM

  useEffect(() => {
    document.title = `Cài đặt trang chủ - ${process.env.REACT_APP_PROJECT}`;

    if (!user.can_homepage) {
      goToPostList();
    }
    if(isMounted){
      fetchData();
    }
    

    handleSession();

    window.addEventListener("beforeunload", () => {
      // remove session when refresh page
      const currentEditHomepageUser = localStorage.get("editingHomepage");
      console.log("before unload", currentEditHomepageUser);
      if (currentEditHomepageUser) {
        deleteSession();
      }
    });

    return () => {
      // remove session when component unmounted
      const currentEditHomepageUser = localStorage.get("editingHomepage");
      console.log("unmount", currentEditHomepageUser);
      if (currentEditHomepageUser) {
        deleteSession();
      }
      setIsMounted(false);
    };
  }, []);
  return (
    <Layout
      backdropStatus={backdropStatus}
      alertDialogStatus={alertDialogStatus}
      setAlertDialogStatus={setAlertDialogStatus}
      alertDialogData={alertDialogData}
      confirmDialogStatus={confirmDialogStatus}
      setConfirmDialogStatus={setConfirmDialogStatus}
      confirmDialogData={confirmDialogData}
      snackBarStatus={snackBarStatus}
      setSnackBarStatus={setSnackBarStatus}
      snackBarData={snackBarData}
    >
      {/*pc*/}
      <BrowserView className="edit-list-home">
        <div className={classes.root}>
          <div className={classes.gridList2}>
            <GridList
              cellHeight="auto"
              className={classes.gridList2}
              cols={3}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(0, 3).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      showDescription={index == 0 ? true : false}
                    />
                  </GridListTile>
                ))}
            </GridList>
            <GridList
              cellHeight="auto"
              className={classes.gridList2}
              cols={4}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(3, 7).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={3 + index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      showDescription={index == 0 ? true : false}
                    />
                  </GridListTile>
                ))}
            </GridList>
            <div className="mt-4 mb-2 w-100 mx-auto border-2-red rounded"></div>
          </div>
        </div>
        
        <div className={classes.root2}>
          <GridList
            cellHeight="auto"
            className={classes.gridList}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(7, 12).map((tile, index) => (
                <GridListTile
                  className={classes.gridItem}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={7 + index}
                    openSetting={openSetting}
                    draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                    onDragStart={handleDragStart}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  />
                </GridListTile>
              ))}
          </GridList>
          <div className="w--330 h--600 bg-grey position-sticky t--60 d-flex align-items-center">
            
          </div>
        </div>
        {/* Box Special 5 bài */}
        {/* Box Special */}
        <div className="box-special rounded-2xl bg-yellow-gradient default-page-width ma mt-4 mx-auto">
          <div className="px-3">
            <div className="box-header d-flex justify-content-between align-items-center position-relative pt-4">
              <img
                src="https://ss-statics.saostar.vn/static/images/ico_special_new.svg"
                alt="special logo"
              />
            </div>
          </div>
          <div className="box-body mt-4 d-flex flex-column flex-wrap align-items-center pb-4">
            <div className="list-cards w-100 px-4 pagination-white-2">
              <Swiper
                slidesPerView={3}
                spaceBetween={15}
                pagination={true}
              >
                {home.tiles &&
                  home.tiles.slice(12, 17).map((tile, index) => {
                    return (
                      <SwiperSlide>
                        <div className="content-pt-2 rounded-3xl bg-white mb-5">
                          <TileItem
                            tile={tile}
                            index={12 + index}
                            openSetting={openSetting}
                            draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div>
        {/* End Box Special */}
        <div className={classes.root2}>
          <div className="w-offset-330">
            <GridList
              cellHeight="auto"
              className={classes.gridList2}
              cols={3}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(17, 22).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={17 + index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    />
                  </GridListTile>
                ))}
            </GridList>
          </div>
          <div className="w--330 h--600 bg-grey position-sticky t--60 d-flex align-items-center">
            
          </div>
        </div>
        <div className={classes.root2}>
          <div className="w-offset-330">
            {/* SaoTV */}
            {/* <img
              className=""
              src="https://ss-images.saostar.vn/2024/3/25/pc/1711340245658/oibbd0wp461-85rd610buj2-kht2i9xtph3.jpg"
              style={{ width: "100% !important" }}
            /> */}
            <GridList
              cellHeight="auto"
              className={classes.gridList2 + " mt-4"}
              cols={3}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(22, 27).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={22 + index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    />
                  </GridListTile>
                ))}
                
            </GridList>
          </div>
          <div className="w--330 h--600 bg-grey position-sticky t--60 d-flex align-items-center">
            
          </div>
        </div>
        {/* Focus News */}
        <div className="rounded-2xl default-page-width ma mt-4 mx-auto text-center">
          {/* <img
            src="https://ss-images.saostar.vn/2024/3/25/pc/1711340810389/55ny3gydjz1-uk513lt7sa2-azd3fz4hfh3.jpg"
            style={{ width: "100% !important" }}
          /> */}
        </div>
        {/* End Focus News */}
        <div className={classes.root2}>
          <div className="w-offset-330">
            <GridList
              cellHeight="auto"
              className={classes.gridList2}
              cols={3}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(27, 32).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={27 + index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    />
                  </GridListTile>
                ))}
                
            </GridList>
          </div>
          <div className="w--330 h--600 bg-grey position-sticky t--60 d-flex align-items-center">
            
          </div>
        </div>
        {/* Box Social Icon 5 bài */}
        <div className={classes.root2}>
          <div className="w-offset-330">
            {/* <div className="box-duoc-quan-tam ma mt-4 rounded-2xl bg-social-icon mx-auto">
              <div className="px-3">
                <div className="box-header d-flex justify-content-between align-items-center position-relative pt-4">
                  <img
                    src="https://ss-statics.saostar.vn/static/images/social-icon.svg"
                    alt=""
                    className="w--64 h--64 ico position-absolute"
                  />
                  <p className="ff-bold fz32 text-black-6 ml-4">
                    SOCIAL ICON
                  </p>
                </div>
              </div>
              <div className="box-body mt-4 d-flex flex-column flex-wrap align-items-center pb-4">
                <div className="list-cards w-100 px-4 pagination-red">
                  <Swiper slidesPerView={2.5} spaceBetween={15} pagination={true}>
                    {home.tiles &&
                      home.tiles.slice(32, 37).map((tile, index) => {
                        return (
                          <SwiperSlide>
                            <div className="content-px-2 rounded-3xl bg-white mb-5">
                              <TileItem
                                tile={tile}
                                index={32 + index}
                                openSetting={openSetting}
                                draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                                onDragStart={handleDragStart}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                showCate={false}
                              />
                            </div>
                          </SwiperSlide>
                        );
                      })}
                  </Swiper>
                </div>
              </div>
            </div> */}
            <GridList
              cellHeight="auto"
              className={classes.gridList2}
              cols={3}
              spacing={10}
            >
              {home.tiles &&
                home.tiles.slice(32, 37).map((tile, index) => (
                  <GridListTile
                    className={classes.gridItem}
                    key={`tile-${index}`}
                    cols={tile.cols || 1}
                    rows={tile.rows || 1}
                  >
                    <TileItem
                      tile={tile}
                      index={32 + index}
                      openSetting={openSetting}
                      draggable={!tile.post || (tile.post && tile.post.pr_type === "0")}
                      onDragStart={handleDragStart}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                    />
                  </GridListTile>
                ))}
                
            </GridList>
          </div>
          <div className="w--330 h--600 bg-grey position-sticky t--60 d-flex align-items-center">
            
          </div>
        </div>
      </BrowserView>
      {/*mobi*/}
      <MobileView>
        <HeaderMobileComponent />
        <div className={classes.rootMobile}>
          <GridList
            cellHeight="auto"
            className={classes.gridListMobile}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(0, 3).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
            {home.tiles &&
              home.tiles.slice(3, 7).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={3 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
            <div className="w-100-important p-0-important ">
              {/* <img src="https://ss-images.saostar.vn/pc/1683276822149/saostar-abvcf6y37y8ybuca.jpg" className="w-100" /> */}
            </div>
            {home.tiles &&
              home.tiles.slice(7, 12).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile2}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={7 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>
        {/* Box Special */}
        
        <div className="box-special bg-yellow-gradient mt-2">
          <div className="box-header d-flex justify-content-between align-items-center px-3 py-2 pt-4">
            <div className="position-relative h--25 d-flex align-items-center justify-content-center">
              <img
                src="https://ss-statics-m.saostar.vn/static/images/ico_special.svg"
                alt="special logo"
              />
              <img
                src="https://ss-statics-m.saostar.vn/static/images/logo_special_black.svg"
                alt="special logo"
              />
            </div>
          </div>
          <div className="box-body mt-4 d-flex flex-column flex-wrap align-items-center pb-4">
            <div className="list-cards w-100 px-2 pagination-white">
              <Swiper
                slidesPerView={1.4}
                breakpoints={{
                  375: {
                    slidesPerView: 1.2,
                  },
                  414: {
                    slidesPerView: 1.4,
                  },
                }}
                spaceBetween={25}
                pagination={true}
              >
                {home.tiles &&
                  home.tiles.slice(12, 17).map((tile, index) => {
                    return (
                      <SwiperSlide>
                        <div className="content-pt-2 rounded-3xl bg-white mb-5">
                          <TileItem
                            tile={tile}
                            index={12 + index}
                            openSetting={openSetting}
                            switchPositionTile={switchPositionTile}
                            handleSwitchPosition={handleSwitchPosition}
                            showCate={false}
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div>
        {/* End Special */}
        <div className={classes.rootMobile}>
          <GridList
            cellHeight="auto"
            className={classes.gridListMobile2}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(17, 22).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile2}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={17 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>

        {/* SaoTV */}
        <div className="">
          {/* <img src="https://ss-images.saostar.vn/2024/3/25/pc/1711357458547/1k6mcyfm4g1-2dqcnseyk42-8bidtj9t7p3.jpg" className="w-100" /> */}
        </div>
        {/* End SaoTV */}

        <div className={classes.rootMobile}>
          <GridList
            cellHeight="auto"
            className={classes.gridListMobile2}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(22, 27).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile2}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={22 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>

        {/* Focus New */}
        <div className="w-100-important p-0-important ">
          {/* <img src="https://ss-images.saostar.vn/2024/3/25/pc/1711357458547/9r3u1nj8rp1-bxd802fiyb2-235yjk76ph3.jpg" className="w-100" /> */}
        </div>
        {/* End Focus New */}

        <div className={classes.rootMobile}>
          <GridList
            cellHeight="auto"
            className={classes.gridListMobile2}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(27, 32).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile2}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={27 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>

        {/* Box Social Icon */}
        {/* <div className="box-duoc-quan-tam ma mt-4 bg-social-icon mx-auto">
          <div className="px-3">
            <div className="box-header d-flex justify-content-between align-items-center position-relative pt-4">
              <img
                width="40px"
                height="40px"
                src="https://ss-statics-m.saostar.vn/static/images/social-icon.svg"
                alt=""
                className="ico w--40 position-absolute"
              />
              <p className="ff-bold fz20 text-black-6">
                SOCIAL ICON
              </p>
            </div>
          </div>
          <div className="box-body mt-4 d-flex flex-column flex-wrap align-items-center pb-4">
            <div className="list-cards w-100 px-2 pagination-red">
              <Swiper slidesPerView={1.2} pagination={true} spaceBetween={20}>
                {home.tiles &&
                  home.tiles.slice(32, 37).map((tile, index) => {
                    return (
                      <SwiperSlide>
                        <div className="content-px-2 rounded-3xl bg-white mb-5">
                          <TileItem
                            tile={tile}
                            index={32 + index}
                            openSetting={openSetting}
                            switchPositionTile={switchPositionTile}
                            handleSwitchPosition={handleSwitchPosition}
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div> */}
        
        <div className={classes.rootMobile}>
          <GridList
            cellHeight="auto"
            className={classes.gridListMobile2}
            cols={3}
            spacing={10}
          >
            {home.tiles &&
              home.tiles.slice(32, 37).map((tile, index) => (
                <GridListTile
                  className={classes.gridItemMobile2}
                  key={`tile-${index}`}
                  cols={tile.cols || 1}
                  rows={tile.rows || 1}
                >
                  <TileItem
                    tile={tile}
                    index={37 + index}
                    openSetting={openSetting}
                    switchPositionTile={switchPositionTile}
                    handleSwitchPosition={handleSwitchPosition}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>
      </MobileView>
      <div>
        <TileSetting
          index={currentTileIndex}
          data={currentTileData}
          open={settingStatus}
          onClose={closeSetting}
        />

        <AutoSetting
          index={currentTileIndex}
          data={currentTileData}
          open={autoSettingStatus}
          onClose={closeAutoSetting}
        />

        <ManualSetting
          index={currentTileIndex}
          data={currentTileData}
          open={manualSettingStatus}
          onClose={closeManualSetting}
          home={home}
        />
      </div>
    </Layout>
  );
};

export default Home;
